/* eslint-disable import/no-named-as-default */
/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';
import {
  isProductAllowed,
  isShippingRestrictedForParent,
} from '../helpers/internationalRestriction';
import { getProductByLocation } from '../helpers/store';
import BackLinkFromYPX from '../shared/BackLinkFromYPX.jsx';
import Background from './background';
import CropOptions from './cropOptions';
import Personalization from './personalization';
import Pose from './pose';
import Product from './product';
import ProductOptions from './productOptions';

const OrderRouter = ({ location }) => {
  const shoot = useSelector((state) => state.shoot?.shoot);
  const shootProducts = useSelector((state) => state.shoot?.shootProducts);
  const parent = useSelector((state) => state.parent);
  const shippingRestricted = isShippingRestrictedForParent(shoot, parent);

  // Guard the YPX sub-routes against direct deep-links. RegularProductConfig
  // already redirects at `/v3/products-regular/:id`, but `/v3/products/:id/...`
  // bypasses it. Catch a restricted, shippable YPX here before any sub-step
  // renders.
  if (
    shippingRestricted &&
    Array.isArray(shootProducts) &&
    shootProducts.length > 0
  ) {
    let product = null;
    try {
      product = getProductByLocation(shootProducts, location);
    } catch (e) {
      // Product not in the loaded shoot products yet — let the route render
      // and rely on the regular not-found path. Nothing to do here.
    }
    if (product && !isProductAllowed(product, true)) {
      return <Redirect to="/v3/offers" />;
    }
  }

  return (
    <div>
      <BackLinkFromYPX />
      <Route
        path="/v3/products/:id/background/:number"
        component={Background}
      />
      <Route path="/v3/products/:id/pose/:number" component={Pose} />
      <Route path="/v3/products/:id/product/:number" component={Product} />
      <Route
        path="/v3/products/:id/productOptions/:number"
        component={ProductOptions}
      />
      <Route
        path="/v3/products/:id/cropOptions/:number"
        component={CropOptions}
      />
      <Route
        path="/v3/products/:id/personalization/:number"
        component={Personalization}
      />
    </div>
  );
};
export default withRouter(OrderRouter);
